import axios from 'axios';

export const PAGE_SIZES = [10, 25, 50, 100];

export const loadAdtFilterOptions = (providerId) => (
	new Promise((resolve, reject) => {
		axios.get(`/providers/${providerId}/get-adt-filter-options`)
			.then(({ data }) => {
				resolve(data);
			})
			.catch(err => reject(err));
	}));

export const loadAdtProviderFilterOptions = (providerId) => (
	new Promise((resolve, reject) => {
		axios.get(`/providers/${providerId}/get-adt-provider-filter-options`, {
			cache: {
				maxAge: 15 * 60 * 1000,
			},
		})
			.then(({ data }) => {
				resolve(data);
			})
			.catch(err => reject(err));
	}));

export const loadExtendedFilterOptions = (providerId) => (
	new Promise((resolve, reject) => {
		axios.get(`/providers/${providerId}/get-adt-extended-filter-options`, {
			cache: {
				maxAge: 15 * 60 * 1000,
			},
		})
			.then(({ data }) => {
				resolve(data);
			})
			.catch(err => reject(err));
	}));

export const loadPayerFilterOptions = (providerId) => (
	new Promise((resolve, reject) => {
		axios.get(`/providers/${providerId}/get-adt-payer-filter-options`, {
			cache: {
				maxAge: 15 * 60 * 1000,
			},
		})
			.then(({ data }) => {
				resolve(data);
			})
			.catch(err => reject(err));
	}));

export const loadAdtNotifications = (providerId, { isPatientSearch, ...currentFilter }) => (
	new Promise((resolve, reject) => {
		axios.post(`/providers/${providerId}/adt-notifications-v2`, isPatientSearch ? {
			patient_filter_options: currentFilter
		} : {
			filter_options: {
				...currentFilter,
			}
		})
			.then(({ data }) => {
				if (data) {
					resolve(data);
				} else {
					reject('NO DATA');
				}
			})
			.catch(err => reject(err));
	})
);

export const markAdtRead = (providerId, adt_id, mark_read_ind = true) => (
	axios.post(`/providers/${providerId}/acknowledge-adt-notification-v2`, { adt_id, mark_read_ind })
);

export const starAdt = (providerId, adt_id, star_ind = true) => (
	axios.post(`/providers/${providerId}/star-adt-notification`, { adt_id, star_ind })
);

export const getNotes = (providerId, adt_id) => (
	axios.get(`/providers/${providerId}/adt-notification-notes`, { params: { adt_id } })
);

export const addNote = (providerId, adt_id, note) => (
	axios.post(`/providers/${providerId}/adt-notification-notes-add`, { adt_id, note })
);

export const getCareTeam = (providerId, adt_id) => (
	axios.get(`/providers/${providerId}/adt-pcp-search`, {
		params: { adt_id },
		cache: {
			exclude: { query: false },
			maxAge: 15 * 60 * 1000,
		},
	})
);

export const getCCDA = (providerId, adt_id) => (
	axios.get(`/providers/${providerId}/view-adt-ccda`, { params: { adt_id } })
);

export const getDischargeSummary = (providerId, adt_id) => (
	axios.get(`/providers/${providerId}/view-adt-ccda-html`, { params: { adt_id } })
);

export const getPatientADTs = (providerId, firstName, lastName, dob, gender, city) => (
	axios.get(`/providers/${providerId}/patient-adts`, { params: { firstName, lastName, dob, gender, city } })
);

export const addPatientToCampaigns = (providerId, data) => (
	axios.post(`/providers/${providerId}/campaign-add`, data)
);

export const resetFilter = (providerId) => (
	axios.post(`/providers/${providerId}/reset-saved-adt-filter`)
);
